/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useAtom, useSetAtom } from 'jotai';
import { useLocation, useNavigationType } from 'react-router-dom';

import { paths } from 'src/routes/paths';

import store from 'src/store';

// 로그인 플로우 전용 페이지 - 이 경로에서 뒤로가기 시 /login 접근 허용
const LOGIN_FLOW_PATHS = [
  paths.auth.termsAgree,
  paths.auth.emailVerfication.root,
  paths.member.password.passwordChange,
  paths.member.password.reissueChangePassword,
  paths.auth.verificationcode,
  paths.auth.storetransfer,
];

export default function useBackNavigationGuard() {
  const location = useLocation();
  const navigationType = useNavigationType();

  const [prevPath, setPrevPath] = useAtom(store.prevPath.prevPathAtom);
  const setIsLoginBlocked = useSetAtom(store.prevPath.isLoginBlockedAtom);

  const currentPath = location.pathname;
  const isLoginPath = currentPath === '/login';
  const isBackNavigation = navigationType === 'POP';

  const isFromLoginFlow = !!prevPath && LOGIN_FLOW_PATHS.includes(prevPath);
  const shouldBlock = isBackNavigation && isLoginPath && !!prevPath && !isFromLoginFlow;

  useEffect(() => {
    if (shouldBlock) {
      console.warn('[useBackNavigationGuard] 뒤로가기 통한 /login 접근 감지 -> 차단');
      setIsLoginBlocked(true);
    } else if (isLoginPath) {
      setIsLoginBlocked(false); // 로그인 페이지지만 뒤로가기가 아님
    } else {
      setIsLoginBlocked(undefined); // 로그인 페이지 아닌 경우
    }

    // 현재 경로가 /login이 아니면 이전 경로 저장
    if (!isLoginPath) {
      setPrevPath(currentPath);
    }
  }, [location.key]);
}
